export const subjectOptions = [
   { value: "2021/2022-3", label: "Mathematics" },
   { value: "2021/2022-2", label: "Biology" },
   { value: "2021/2022-1", label: "Physics" },
];
export const classOptions = [
   { value: "2021/2022-3", label: "JSS 1" },
   { value: "2021/2022-2", label: "JSS 2" },
   { value: "2021/2022-1", label: "JSS 3" },
];
export const assignmentTypeOptions = [
   { value: "false", label: "Assignment" },
   { value: "true", label: "Group Assignment" },
]